module.exports = __webpack_public_path__ + "img/wxQR.dc33769b.jpg";